export default "__VITE_ASSET__BDxVm7FH__"